import React from 'react';

import BottomSheetOptions from 'components/BottomSheetOptions';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { changeLanguage } from 'i18n';
import { Country } from 'models/country';
import { changeUserLanguage } from 'services/preferenceService';
import { extractErrorMessage } from 'utils/generic';

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  setLoading: (loading: boolean) => void;
}

const COUNTRIES: Country[] = [
  {
    id: 'pt-BR',
    name: 'Brasil',
    culture: 'pt-BR',
    documentType: 'pt-BR',
  },
  {
    id: 'es-CO',
    name: 'Colombia',
    culture: 'es-CO',
    documentType: 'es-CO',
  },
  {
    id: 'en-US',
    name: 'United States',
    culture: 'en-US',
    documentType: 'en-US',
  },
];

const OPTIONS = [
  { id: 'es-CO', name: 'Español' },
  { id: 'pt-BR', name: 'Português' },
  { id: 'en-US', name: 'English' },
];

const LanguageSelector = ({ show, setShow, setLoading }: Props) => {
  const { t } = useStoreTranslation();
  const toast = useToast();

  const handleChange = async (language: string) => {
    try {
      if (!language) return;

      const country = COUNTRIES.find((c) => c.id === language);
      if (!country) return;

      setLoading(true);
      changeLanguage(language);

      await changeUserLanguage(language);
      toast.add({ type: 'success', message: t('preferences.languageChanged') });
    } catch (error) {
      window.scrollTo(0, 0);
      toast.add({
        type: 'danger',
        message: extractErrorMessage(error) || t('defaultError.default'),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BottomSheetOptions
      style={{ maxHeight: 500, overflowY: 'scroll' }}
      title={t('preferences.options.language')}
      show={show}
      data={OPTIONS}
      onClose={() => setShow(false)}
      onChange={handleChange}
    />
  );
};

export default LanguageSelector;
